module.exports = __webpack_public_path__ + "assets/img/9092393c5eea651208438ec3da727136.svg";